// extracted by mini-css-extract-plugin
export default {"faqContainer":"QuestionBox_faqContainer__HeYk5","faqItem":"QuestionBox_faqItem__Sc0Ez","faqQuestion":"QuestionBox_faqQuestion__dVdUA","faqAnswer":"QuestionBox_faqAnswer__rQ9Kn"};